"use client";

import { c as _c } from "react/compiler-runtime";
import { FiTrendingUp } from "react-icons/fi";
const SCALE = [{
  value: 1,
  label: "Very unlikely"
}, {
  value: 2,
  label: "Unlikely"
}, {
  value: 3,
  label: "Neutral"
}, {
  value: 4,
  label: "Likely"
}, {
  value: 5,
  label: "Very likely"
}];
const PrescribeLikelihood = t0 => {
  const $ = _c(23);
  const {
    prescribeLikelihood,
    setPrescribeLikelihood,
    productName,
    onBack,
    onNext
  } = t0;
  const isFormValid = prescribeLikelihood > 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><FiTrendingUp className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Prescribing Intent</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = productName || "this therapy";
  let t3;
  if ($[1] !== t2) {
    t3 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">How likely are you to prescribe <span className="font-semibold">{t2}</span> once it is approved?</p>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== prescribeLikelihood || $[4] !== setPrescribeLikelihood) {
    t4 = SCALE.map(s => {
      const selected = prescribeLikelihood === s.value;
      return <button key={s.value} type="button" onClick={() => setPrescribeLikelihood(s.value)} aria-pressed={selected} className={`flex-1 px-2 sm:px-3 py-2 sm:py-2.5 rounded-lg border-2 text-xs sm:text-sm font-semibold font-poppins transition-all inline-flex items-center justify-center gap-1.5 ${selected ? "bg-primary-primaryBlue text-white border-primary-primaryBlue" : "bg-white text-gray-700 border-gray-200 hover:border-primary-primaryBlue/50"}`}><span className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] sm:text-[11px] font-bold flex-shrink-0 ${selected ? "bg-white/25 text-white" : "bg-gray-100 text-gray-500"}`}>{s.value}</span><span className="truncate">{s.label}</span></button>;
    });
    $[3] = prescribeLikelihood;
    $[4] = setPrescribeLikelihood;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-5"><div className="grid grid-cols-2 sm:grid-cols-5 gap-2">{t4}</div></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t1}{t3}{t5}</div></div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onBack) {
    t7 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[11] = onBack;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !isFormValid;
  const t9 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${isFormValid ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t10;
  if ($[13] !== onNext || $[14] !== t8 || $[15] !== t9) {
    t10 = <button onClick={onNext} disabled={t8} className={t9}>Next</button>;
    $[13] = onNext;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t7}{t10}</div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t6) {
    t12 = <>{t6}{t11}</>;
    $[20] = t11;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default PrescribeLikelihood;